import React from 'react';
import { Card } from "react-bootstrap";
import success_MateGedeon from "../../assets/img/success_MateGedeon.jpg";
import ShowMoreText from "react-show-more-text";
import proj_speech_recog from "../../assets/img/proj_speech_recog.png";

const Mate_Gedeon_speech_recog = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_speech_recog} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={success_MateGedeon}
              /* this will be the text on the banner */
              alt="Learning to Listen: Curriculum Learning for Speech Recognition"
            />{" "}
            <p className="text7">Máté Gedeon</p>
            <br />
            <p className="text8">
              PhD Student{" "}
            </p>
            <p className="text8">Department of Telecommunication and Artificial Intelligence, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Neural networks are usually trained by presenting examples in a random order. 
            Humans, however, rarely learn this way: we typically begin with simple exercises 
            and gradually move towards more difficult ones. Could speech recognition systems 
            also benefit from such a curriculum?
            <br />
            <br />
            In this project, students will investigate how the order of training examples affects 
            a speech recognition model. Recordings can be ranked using intuitive measures such as 
            duration, speech rate, background noise, or the errors made by an existing model. 
            Several training strategies will then be compared, including random ordering, learning 
            from easy to difficult examples, and gradually introducing more challenging recordings.
            <br />
            <br />
            The project will use existing speech recognition models and prepared training pipelines, 
            so no previous experience with speech technology is required. A basic understanding of 
            neural network training and experience with Python are expected. The analysis will involve 
            learning curves, statistical tests, and visualizations. Possible extensions include combining 
            several measures of difficulty or designing an adaptive curriculum that changes according 
            to the model's progress.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Mate_Gedeon_speech_recog;